import React, { useState, useEffect } from "react";
import { Container, Table } from "react-bootstrap";
import Footer from "./footer";
import DashboardNavbar from "./DashboardNavbar";
import { toast } from "react-toastify";
import { getData } from '../api/protectedApi'
import ReactPaginate from 'react-paginate';
import {
  FaLifeRing,
  FaSitemap,
  FaHandHoldingUsd,
  FaCoins,
  FaChartBar,
  FaMoneyBillWave,
  FaUserPlus,
  FaSpinner,
} from "react-icons/fa";
import { Link } from "react-router-dom";


const DirectIncome = () => {
  const [userName, setUserName] = useState("");
  const [incomeData, setIncomeData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [startRec, setStartRec] = useState(1)
  const [dashboard, setDashboard] = useState({});
  const [incomeSum, setIncomeSum] = useState(0)
  const perPage = 5;
  const ChangePage = (page) => {
    getIncomeData(page);
  }
  const getIncomeData = async (page = 0) => {
    await getData("/level_income?per_page=" + perPage + "&page=" + page)
      .then((res) => {
        if (page > 1) {
          setStartRec(((page - 1) * perPage) + 1)
        } else {
          setStartRec(1)
        }
        setIncomeData(res.data.data)
        setTotalPages(parseInt(res.data.pagination.total_pages))
        setIncomeSum(res.data.income_balance)
      }).catch((err) => console.error("ee", err));
  }

  const loadData = async () => {
    try {
      const res = await getData("/dashboard");
      if (res?.data?.data) {
        setDashboard(res.data.data);
      }
    } catch (error) {
      toast.error("Failed to load dashboard");
    }
  };
  useEffect(() => {
    getIncomeData()
    loadData()
  }, []);
  // const totalAmount = incomeData.reduce((sum, item) => sum + item.amount, 0);
  const handlePageChange = ({ selected }) => {
    getIncomeData(selected);
  };
  return (
    <div
      style={{
        backgroundColor: "#0d0e13",
        minHeight: "100vh",
        padding: "40px 0",
        color: "#fff",
      }}
    >
      {/* NAVBAR */}
      <DashboardNavbar />
      <section>
        <div className="container pt-5">
          <div className="mb-4">
            <div className="welcome">Welcome to Hifi Internationals</div>
            <div className="hello">
              Hello, {userName || "User"}
            </div>

          </div>
        </div>
      </section>
      {/* POOL INFO */}
      <section>
        <div
          className="container-fluid py-3"
          style={{ backgroundColor: "#141245" }}
        >
          <div className="container">
            <div className="mb-4">
              <div className="hifi1-race-label">Active : $30</div>
              <div className="hifi1-race-title">Activation Pool</div>
            </div>

            <div className="row g-4">
              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaSpinner size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Status</div>
                  <div className="hifi1-card-value">
                    {dashboard?.pool_status}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon blue">
                    <FaUserPlus size={40} />
                  </div>
                  <div className="hifi1-card-label">Total Referrals</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directs || 0}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon orange">
                    <FaMoneyBillWave size={40} />
                  </div>
                  <div className="hifi1-card-label">Referral Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.directIncome || 0}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-12">
                <div className="hifi1-pool-card">
                  <div className="hifi1-icon darkblue">
                    <FaChartBar size={40} />
                  </div>
                  <div className="hifi1-card-label">Pool Bonus</div>
                  <div className="hifi1-card-value">
                    {dashboard?.poolIncome || 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* QUICK LINKS */}
      <section className="hifi1section py-5">
        <div className="container">
          <div className="row g-4 justify-content-center hifi1section-2">

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolinfo" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaLifeRing size={40} />
                  <span>POOL INFO</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/levelincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaSitemap size={40} />
                  <span>LEVEL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/directincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaHandHoldingUsd size={40} />
                  <span>REFERRAL INCOME</span>
                </div>
              </Link>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6">
              <Link to="/poolincome" className="text-decoration-none">
                <div className="hifi-card hifi1-icon darkblue">
                  <FaCoins size={40} />
                  <span>POOL INCOME</span>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="directs-wrapper">
            <div className="directs-title">
              Level Income (Total: ${incomeSum.toLocaleString()})
            </div>
            <div className="table-responsive">
              <table className="table directs-table align-middle">
                <thead>
                  <tr>
                    <th></th>
                    <th>#</th>
                    <th>Amount</th>
                    <th>Hash</th>
                    <th></th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody className="table directs-table align-middle">
                  {incomeData.length > 0 ? (
                    incomeData.map((item, index) => (
                      <tr key={index}>
                        <td></td>
                        <td>{startRec + index}</td>
                        <td>{item.amount}</td>
                        <td>{item.hash}</td>
                        <td></td>
                        <td>{item.Date}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && (
              <ReactPaginate
                previousLabel={<i className="fa fa-chevron-left"></i>}
                nextLabel={<i className="fa fa-chevron-right"></i>}
                pageCount={totalPages}
                onPageChange={handlePageChange}
                containerClassName="pagination custom-pagination justify-content-center mt-4"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
              />
            )}
          </div>

        </div>
      </section>
      <Footer />
    </div>
  );
};

export default DirectIncome;
